import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { createSavedView, updateSavedView } from "../../../../api/t2tSavedViewsApi";

export default function SaveViewModal({ show, onClose, onSaved, existingView, currentConfig }) {
  const [name, setName]           = useState("");
  const [description, setDescription] = useState("");
  const [shareType, setShareType] = useState("private");
  const [saving, setSaving]       = useState(false);
  const [error, setError]         = useState("");

  const isEdit = Boolean(existingView);

  useEffect(() => {
    if (existingView) {
      setName(existingView.name || "");
      setDescription(existingView.description || "");
      setShareType(existingView.share_type || "private");
    } else {
      setName("");
      setDescription("");
      setShareType("private");
    }
    setError("");
  }, [existingView, show]);

  const handleSave = async () => {
    if (!name.trim()) { setError("Name is required."); return; }
    setSaving(true);
    setError("");
    try {
      const body = { name: name.trim(), description, share_type: shareType, view_config: currentConfig || {} };
      let result;
      if (isEdit) {
        result = await updateSavedView(existingView.id, body);
      } else {
        result = await createSavedView(body);
      }
      onSaved(result.data);
      onClose();
    } catch (e) {
      setError(e.message || "Save failed");
    } finally {
      setSaving(false);
    }
  };

  if (!show) return null;

  return (
    <div className="modal d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.45)" }}>
      <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 440 }}>
        <div className="modal-content">
          <div className="modal-header py-3 px-4">
            <h6 className="modal-title fw-semibold mb-0">{isEdit ? "Edit Saved View" : "Save View"}</h6>
            <button type="button" className="btn-close" onClick={onClose} />
          </div>
          <div className="modal-body px-4 py-3 d-flex flex-column gap-3">
            {error && <div className="alert alert-danger py-2 mb-0" style={{ fontSize: 13 }}>{error}</div>}
            <div>
              <label className="form-label small fw-semibold">Name *</label>
              <input
                className="form-control form-control-sm"
                value={name}
                onChange={e => setName(e.target.value)}
                placeholder="e.g. My open requests"
                maxLength={80}
              />
            </div>
            <div>
              <label className="form-label small fw-semibold">Description</label>
              <textarea
                className="form-control form-control-sm"
                rows={2}
                value={description}
                onChange={e => setDescription(e.target.value)}
                placeholder="Optional description"
              />
            </div>
            <div>
              <label className="form-label small fw-semibold">Visibility</label>
              <select
                className="form-select form-select-sm"
                value={shareType}
                onChange={e => setShareType(e.target.value)}
              >
                <option value="private">Private (only me)</option>
                <option value="team">Team (everyone)</option>
                <option value="specific_users">Specific users</option>
                <option value="specific_roles">Specific roles</option>
              </select>
            </div>
          </div>
          <div className="modal-footer py-2 px-4">
            <button className="btn btn-sm btn-secondary" onClick={onClose} disabled={saving}>Cancel</button>
            <button className="btn btn-sm btn-primary" onClick={handleSave} disabled={saving}>
              {saving ? <span className="spinner-border spinner-border-sm me-1" /> : null}
              {isEdit ? "Update" : "Save View"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

SaveViewModal.propTypes = {
  show:          PropTypes.bool.isRequired,
  onClose:       PropTypes.func.isRequired,
  onSaved:       PropTypes.func.isRequired,
  existingView:  PropTypes.object,
  currentConfig: PropTypes.object,
};
